import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';
import { firebaseConfig } from './firebaseConfig';

const EMULATOR_HOST = process.env.EMULATOR_HOST || '127.0.0.1';

// Initialize Firebase app if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  if (process.env.NODE_ENV === 'development') {
    try {
      firebase.auth().useEmulator(`http://${EMULATOR_HOST}:9099`);
      firebase.firestore().useEmulator(EMULATOR_HOST, 8008);
      firebase.functions().useEmulator(EMULATOR_HOST, 5001);
      firebase.storage().useEmulator(EMULATOR_HOST, 9199);
    } catch (e) {
      console.log('Firebase emulator error:', e);
    }
  }
}

export default firebase;
